import { render, staticRenderFns } from "./robot.vue?vue&type=template&id=cc500080&scoped=true&"
import script from "./robot.vue?vue&type=script&lang=js&"
export * from "./robot.vue?vue&type=script&lang=js&"
import style0 from "./robot.vue?vue&type=style&index=0&id=cc500080&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc500080",
  null
  
)

export default component.exports